<section class="section-8">
    <div
        class="container"
        [ngClass]="{ 'mb-6 mb-lg-7 mt-4 pt-4': hasSlidesAvailable }"
    >
        @if (hasSlidesAvailable) {
        <div class="text-center">
            <h2
                [innerHtml]="
                    'PRODUCT-PAGE_GLOBAL_RELATED-PRODUCTS_HEADING_TEXT'
                        | translate
                "
                class="text-blue-300"
            ></h2>
        </div>
        }

        <vision2-carousel-equipment
            [cmsComponent]="'products-related-products'"
            [isProductPage]="true"
            [productData]="productData"
            (slidesAvailable)="onSlidesAvailableChange($event)"
        ></vision2-carousel-equipment>
    </div>
</section>
